/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
function o(o,t,n){return o.goTo(t,n)}function t(){return(o,t)=>o.goTo(t.target,{...t.options,animate:!1})}export{o as goTo,t as makeGoToWithoutAnimation};
